import React from 'react'
import SlaughterWaste from '../../components/SlaughterWaste';

const AnimalWasteManagement = () => {
  return (
    <SlaughterWaste/>
  )
}

export default AnimalWasteManagement;
